// extracted by mini-css-extract-plugin
export default {"settings":"QwK3hQ5BHwAASRzUSBHE","stickyHeader":"O1e7rO10aIi2fCqIwJ_R"};